export class ClientRequestData { }
